import React from 'react';
import ChangeTable from './ChangeTable';

const GraphDocs = () => {
  return (
    <ChangeTable
      title="Recent Microsoft Graph Documentation Changes"
      dataSource="graph-changes.json"
      showGuideLink={false}
    />
  );
};

export default GraphDocs;